<template lang="pug">
  div.video
    div.embed-video
      div.video-frame
        video(:controls="control",
              @mouseover="() => control = true",
              @mouseleave="() => control = false",
              video-auto-ctrl,
              loop,
              muted,
              preload,
              controls,
              poster="../../assets/images/video-poster.png"
              src="//stance.oss-cn-hangzhou.aliyuncs.com/videos/about.mp4")
          source(src="//stance.oss-cn-hangzhou.aliyuncs.com/videos/about.mp4", type="video/mp4")
          p Sorry, your browser doesn't support embedded videos,
</template>
<script>
export default {
  name: 'VideoFrame',
  data () {
    return {
      control: false
    }
  }
}
</script>
<style lang="scss" scoped>
.video {
  padding: 0 15px;
}
.embed-video {
  position: relative;
  display: block;
  overflow: hidden;
  max-width: 100%;
  width: 100%;
  &:before {
    position: relative;
    padding-top: 56.25%;
    display: block;
    content: "";
  }
    .video-frame {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 100%;
      border: 0;
    }
    video {
      max-width: 100%;
      width: 100%;
      height: 100%;
    }
}

@media only screen and (min-width: 768px) {
  .video-frame {
    max-width: 58.888%;
    width: 100%;
    margin: 0 auto;
  }
}
</style>
